import React, { useEffect } from "react";
import styles from "./Character.module.scss";
import charImg from "../images/characters/character-sample.jpg";
import { useTranslation } from 'react-i18next';
import {
  numberWithCommas,
  CDN_URI,
  CDN_URI_BASE,
  handleMissingImg
} from "../common/utilities";
import characterMap from "../json/characters";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import characterMisingImg from "../images/_char-missing.jpg";


export default function({ data }) {
  if (data == null) {
    return null;
  }
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { t, i18n } = useTranslation();

  // console.log(theme.breakpoints.down("sm")); //dng 

  const parsedData = {
    charName: data.DISPLAY_NAME,
    killCount: data.CHAR_KILL
  };

  const imgPath = `${CDN_URI_BASE}web/inventory/characters/700_500/`;

  return (
    <div className={clsx(styles.characters_container, mobile && styles.mobile)}>
      <div className={clsx(styles.info, mobile && styles.mobile)}>
        <span className={styles.heading}>{t('Current Character')}</span>
        <span className={clsx(styles.name, mobile && styles.mobile)}>
          {parsedData.charName}
        </span>
        <span className={styles.kill_count}>
          {t('{{count}} Kills', {count: numberWithCommas(parsedData.killCount)})}
        </span>
      </div>
      {/* <div className={styles.char_img_container}> */}
        <img
          className={clsx(styles.char_img, mobile && styles.mobile)}
          src={`${imgPath}${data.CHAR_ITEM_CODE}.jpg`}
          onError={handleMissingImg(characterMisingImg)}
        />
      {/* </div> */}
    </div>
  );
}
